import { Box, CircularProgress } from '@mui/material';

export const LoadingOverlay = ({ loading, children, minHeight = 200 }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight }}>
        <CircularProgress />
      </Box>
    );
  }
  return children;
};

export const PageLoader = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress size={48} />
  </Box>
);
